/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CheckboxModule,AccordionModule} from 'primeng/primeng'

//import { InterComponent } from '../intermediate/inter.component'
import { CommonService} from './../common.service'
import { WaterMapsComponent} from './water-maps.component'
import { AppRoutingModule } from './../app-routing.module';
import { EsriMapModule } from './../map-esri/esrimap.module'
import { HeaderModule } from './../header/header.module'
import { LocationModule } from './../location/location.module'
/*import { NgbdModalContent } from './modal.component';*/

@NgModule({
  //declarations: [WaterMapsComponent,NgbdModalContent],
  declarations: [WaterMapsComponent],
  imports: [BrowserModule,CommonModule,FormsModule, CheckboxModule, AppRoutingModule,EsriMapModule,HeaderModule,AccordionModule,LocationModule,NgbModule],
  providers: [CommonService],
  //entryComponents: [NgbdModalContent],
  exports: []
})

export class WaterMapsModule { }
